var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tms-status f-b",class:_vm.fz,style:({
        'background-color': _vm.bgColor,
        color: _vm.color ? _vm.color : '',
        padding: _vm.isShowBg ? '6px' : '0',
    })},[_vm._v("\n    "+_vm._s(_vm.privateOrderStatus)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0217220","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orderStatusShow/orderStatusShow.vue
// module id = null
// module chunks = 